const Cross = () => {

    return (
        <svg viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M14.5455 12.2L22.2375 4.50801L23.8237 2.92176C24.0577 2.68776 24.0577 2.30751 23.8237 2.07351L22.1265 0.376262C21.8925 0.142262 21.5122 0.142262 21.2782 0.376262L12 9.65451L2.72175 0.375512C2.48775 0.141512 2.1075 0.141512 1.8735 0.375512L0.1755 2.07276C-0.0585 2.30676 -0.0585 2.68701 0.1755 2.92101L9.4545 12.2L0.1755 21.4783C-0.0585 21.7123 -0.0585 22.0925 0.1755 22.3265L1.87275 24.0238C2.10675 24.2578 2.487 24.2578 2.721 24.0238L12 14.7455L19.692 22.4375L21.2782 24.0238C21.5122 24.2578 21.8925 24.2578 22.1265 24.0238L23.8237 22.3265C24.0577 22.0925 24.0577 21.7123 23.8237 21.4783L14.5455 12.2Z" />
        </svg>
    );
}

export default Cross;